import React from "react";
import "./../styles/Footer.css";
import {Link} from "react-router-dom";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-links">
                    <Link to="/">Home</Link>
                    <Link to="/services">Services</Link>
                    <Link to="/contact">Contact</Link>
                </div>
                <div className="footer-info">
                    <p>© 2024 Curve Intel. All Rights Reserved. | Email: info@curveintel.com</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
